import { Environment } from '@noths/polaris-server-content-fetching';

/** Redis freshness window for the Inspiration library and term names (seconds). */
export const INSPIRATION_CONTENTSTACK_CACHE_TTL_SECONDS = 60 * 5;

/** Preview must show what an editor has just saved, so it skips Redis. */
export const inspirationAllowCaching = (env: Environment) => env !== Environment.Preview;
